import Vue from 'vue'
import configs from '@/config'
import store from '@/vuex/store'

let resource = null

const actions = {
  getMyPlan: {
    method: 'GET',
    url: `${configs.baseUrl}/api/pricing/my-plan/`,
  },
  getMyPlanWithStripeSnapshot: {
    method: 'GET',
    url: `${configs.baseUrl}/api/pricing/my-plan/?useSnapshotStripeInfo=true`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}
const getMyPlan = () => {
  const params = store.getters['featureToggles/canUseStripeSnapshot']
    ? { useSnapshotStripeInfo: true }
    : {}
  return resource.getMyPlan(params)
}

export default {
  initResource,
  getMyPlan,
}
